// eslint-disable-next-line import/no-extraneous-dependencies
import { parse } from 'cookie';

import { CookieService } from '@/Module/Core/Service';

export const isShadUser = (req?: any): boolean => {
  if (typeof window !== 'undefined') {
    // ✅ Client-side
    return CookieService.getShadToken();
  }

  // ✅ Server-side
  if (req?.headers?.cookie) {
    const cookies = parse(req.headers.cookie);
    return !!cookies.shadToken;
  }

  return false;
};
